import { render } from "./Header.htm?vue&type=template&id=dd08c964&scoped=true"
import script from "./Header.js?vue&type=script&lang=js"
export * from "./Header.js?vue&type=script&lang=js"

import "./Header.scss?vue&type=style&index=0&id=dd08c964&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd08c964"]])

export default __exports__